export default {
    methods: {
        infiniteHandler ($state, MUTATION_METHOD, hasMutationMethod = true, dataModel =- "") {
            setTimeout(function () {
                this.axios.get(`${this.fetchUrl}&offset=${this.offset}`)
                    .then(({data}) => {
                        if (data.results.length > 0) {
                            if(hasMutationMethod) {
                                if(MUTATION_METHOD === "SET_BLOG_TAGS") {
                                    this[MUTATION_METHOD](
                                        [...this.tags, ...data.results].map(item => ({
                                            ...item,
                                            color_code: item.color_code ? item.color_code :
                                                this.defaultColors[Math.floor(Math.random()*this.defaultColors.length)]
                                        })))

                                } else if (MUTATION_METHOD === "SET_MY_BLOGS") {
                                    let blogs = []
                                    if (this.tab === 0) blogs = [...this.approved]
                                    if (this.tab === 1) blogs = [...this.pending]
                                    if (this.tab === 2) blogs = [...this.drafts]
                                    if (this.tab === 3) blogs = [...this.rejected]
                                    this[MUTATION_METHOD]({tabIndex: this.tab, blogs: [...blogs, ...data.results]})

                                } else {
                                    // sets popular, all, bookmarked blogs from their mutation methods
                                    this[MUTATION_METHOD]([...this.blogs, ...data.results])
                                }
                            } else {
                                // update data model with new fetched data, if there is no mutation
                                this[dataModel] = [...this[dataModel], ...data.results]
                            }

                            if (data.next) this.offset += 5;
                            else $state.complete();
                            $state.loaded();

                        } else $state.complete();
                    })
            }.bind(this), 1000);
        }
    }
}
